import React from 'react'

export const ChatVoice = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_6797)'>
      <path
        d='M4.92899 19.071C3.99903 18.1434 3.26153 17.0413 2.75887 15.8278C2.25622 14.6143 1.99832 13.3135 1.99999 12C1.99999 6.477 6.47699 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22H1.99999L4.92899 19.071ZM11 6V18H13V6H11ZM6.99999 9V15H8.99999V9H6.99999ZM15 9V15H17V9H15Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_6797'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
